import { useQuery } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { urls } from '../../config/urls';

export const useCategories = () => {
  return useQuery('categories', () =>
    axiosInstance.get(urls.categories.all).then((res) => res.data)
  );
};
